import { Box, Menu, MenuItem, MenuList } from "@mui/material";
import { taskColumnOptionSelectByQuery } from "@common-reducers/DBServiceThunks";
import { useAppSelector } from "@common-reducers/hooks/store.hook";

import { CSSProperties } from "react";
import { TaskColumnOption } from "@common-models/task-column-option";
import { NullableId } from "@common/types/interface";

const styling: CSSProperties = {
    height: 25,
    borderRadius: '5px',
    flex: 'auto',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis'
}

type ColumnOptionsSelectorProps = {
    boardId: string | undefined;
    columnId: NullableId | string | undefined;
    onSelectOption: (option: TaskColumnOption) => void;
    anchorEl: HTMLElement | null;
    handleClose: () => void;
};

const ColumnOptionsSelector = ({ boardId, columnId, onSelectOption, anchorEl, handleClose }: ColumnOptionsSelectorProps) => {
    const columnOptions = useAppSelector((state) => taskColumnOptionSelectByQuery(state.DBTaskColumnOptionReducer, {
        boardId,
        columnId,
        $or: [{ deleted: { $exists: false } }, { deleted: false }],
    }))

    return (
        <Menu anchorEl={anchorEl}
            open={Boolean(anchorEl)}
            onClose={handleClose}>
            <MenuList>
                {columnId ? (
                    <Box>{columnOptions.map((option) => (
                        <MenuItem key={option.label} onClick={() => onSelectOption(option)} >
                            <button
                                aria-haspopup="true"
                                style={{
                                    backgroundColor: option?.bgcolor ?? '#c4c4c4f5',
                                    color: "var(--color-surface)",
                                    fontWeight: "600",
                                    border: 'none',
                                    ...styling
                                }}
                            >
                                {option?.label ?? ''}
                            </button>
                        </MenuItem>
                    ))}</Box>) : <Box px={2}>First select column</Box>}
            </MenuList>
        </Menu>
    )
}
export default ColumnOptionsSelector